function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getOwner } from '@ember/application';
import Service from '@ember/service';
import environment from '@square/environment-utils/environment';
export default class EmberMultipassConfigService extends Service {
  constructor(properties) {
    super(properties);
    _defineProperty(this, "environment", void 0);
    const env = getOwner(this).lookup('environment:current') || environment();
    this.environment = env.name;
  }
  get isProduction() {
    return this.environment === 'production';
  }
  get isStaging() {
    return this.environment === 'staging';
  }
}